// @flow

import React from "react";
import { useFlags } from "../../utils/featureFlags";

const FeatureFlagsWrapper = (Component: React.Node) => (props: any) => {
  const flags = useFlags();

  return <Component flags={flags} {...props} />;
};

export default FeatureFlagsWrapper;
